import { Shell } from "../components/shell/Shell";

export const PageRoot = () => {
  return (
    <Shell />
  );
}
